import React from 'react'

import {
  Light,
  Light1,
  Light2,
  Light3,
  Light4,
  Light5,
  Light6,
  Light7,
  Light8,
  Light9,
  Light10,
  Light12,
} from './lineAnimation.style'

const LineAnimation = () => {
  return (
    <Light>
      <Light1 />
      <Light2 />
      {/* <Light3 /> */}
      <Light4 />
      {/* <Light5 /> */}
      <Light6 />
      {/* <Light7 />
      <Light8 />
      <Light9 />
      <Light10 />
      <Light12 /> */}
    </Light>
  )
}

export default LineAnimation
